import { Flex, SimpleGrid, Text, Image, Box } from "@chakra-ui/react";

import { defiIcons } from "@constants/defi";
import { StrapiCard, StrapiSectionDetail } from "@customtypes/global";

import Icon from "@components/Icon";

import Section from "../Section";

interface EcosystemProps {
  sectionDetails: StrapiSectionDetail;
  ecosystems: StrapiCard[];
}

const Ecosystem = ({ sectionDetails, ecosystems }: EcosystemProps) => {
  return (
    <Section
      title={sectionDetails.title}
      subTitle={sectionDetails.sub_title}
      id={sectionDetails.section_id}
    >
      {ecosystems && (
        <SimpleGrid
          columns={{ base: 2, md: 3, xl: 4 }}
          mt={{ base: "2.5rem", lg: "4rem" }}
          gap={{ base: "12px", lg: "1.5rem" }}
          w="100%"
          alignItems="center"
        >
          {ecosystems.map((data: StrapiCard) => {
            return (
              <Flex
                align="center"
                gap={{ base: "12px", lg: "1rem" }}
                w={{ base: "100%", xl: 261 }}
                p={{ base: "12px", xl: "24px" }}
                bg="#E6F8EF"
                borderRadius={24}
                key={data.key}
              >
                <Flex borderRadius="50%" overflow="hidden">
                  {data?.img_key && (
                    <>
                      {defiIcons[data?.img_key].dark.src ? (
                        // Case for PNG
                        <Image
                          src={defiIcons[data?.img_key].dark.src}
                          alt={`${data.title}-image`}
                          width={{ base: "30px", lg: "48px" }}
                          height={{ base: "30px", lg: "48px" }}
                        />
                      ) : (
                        // Case for SVG
                        <Box
                          width={{ base: "30px", lg: "48px" }}
                          height={{ base: "30px", lg: "48px" }}
                        >
                          <Icon
                            Icon={defiIcons[data?.img_key].dark}
                            width="100%"
                            height="100%"
                          />
                        </Box>
                      )}
                    </>
                  )}
                </Flex>
                <Text
                  fontSize={{ base: "12px", lg: "16px" }}
                  fontWeight={{ base: "600", xl: "700" }}
                >
                  {data.title}
                </Text>
              </Flex>
            );
          })}
        </SimpleGrid>
      )}
    </Section>
  );
};

export default Ecosystem;
